<template>
    <MainContent>
        <template #header>
            <PageTitle 
                title="Formulario para crear una plantilla de Whatsapp" 
                class="pb-3" 
            />
        </template>

        <template #content>
            <FormPlantilla :plantilla="plantilla" :loading="loading" :errors="errors" @terminado="crearPlantilla" />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import PageTitle from "@/components/backend/components/PageTitleComponent";
    import FormPlantilla from "@/components/backend/plantillas-whatsapp/FormPlantilla.vue";

    export default {
        name: "CrearPlantilla",
        data() {
            return {
                loading: false,
                errors: [],
                plantilla: {
                    name: "",
                    language: { value: 'es_ES', label: 'Español (ES)' },
                    components: {
                        header: { text: "" },
                        body: { text: "" },
                        footer: { text: "" },
                        buttons: []
                    }
                }
            };
        },
        methods: {
            crearPlantilla() {
                this.loading = true;

                const data = {
                    filters: {},
                    teatro_id: this.teatro.id,
                    name: this.plantilla.name,
                    language: this.plantilla.language.value,
                    components: Object.keys(this.plantilla.components).reduce((acc, key) => {
                        const component = this.plantilla.components[key];
                    
                        if (key === 'buttons' && component.length > 0) {
                            acc[key] = component;
                        } else if (component.text && component.text.trim() !== "") {
                            acc[key] = component;
                        }

                        return acc;
                    }, {})
                };

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.crear'), data).then(res => {
                    this.$toast.success(res.data?.message);
                    this.errors = [];
                    this.$router.push({ name: 'back.plantillas-whatsapp.index' });
                }).catch(error => {
                    if(error.response?.data?.errors) {
                        this.errors = error.response?.data?.errors;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContent,
            PageTitle,
            FormPlantilla
        }
    };
</script>